import { Api } from './Api'

const accountPathTo = {
  create_stripe_account: () => {
    return Api.request({
      url: '/account/create_stripe_account.json',
      method: 'get'
    })
  },
  get: () => {
    return Api.request({
      url: '/account.json',
      method: 'get'
    })
  },
  update_avatar: (data) => {
    return Api.request({
      url: '/account/update_avatar.json',
      method: 'put',
      data: {
        user: data
      }
    })
  },
  update_profile: (data) => {
    return Api.request({
      url: '/account/update_profile.json',
      method: 'put',
      data: {
        user: data
      }
    })
  }
}


export default accountPathTo
